/**
 * ローカルストレージからデフォルトのステータスフィルタ値を取得
 */
export const DISPLAY_FILTER_KEY = "display-company-filter-status";
export const displayFilterStatus = (): string[] => {
  const storageStatus = localStorage.getItem(DISPLAY_FILTER_KEY);
  if (!storageStatus) return ["0", "1", "2", "3", "4", "5"];
  return JSON.parse(storageStatus);
};
